import { TelephonyUser, TelephonyUserEntities } from 'features/sip/types';
import { UserId } from 'features/users/types';

export const normalizeTelephonyUsers = (users: TelephonyUser[]) => {
  const entities: TelephonyUserEntities = {};
  const ids: UserId[] = [];

  for (const user of users) {
    entities[user.id] = user;
    ids.push(user.id);
  }

  return { entities, ids };
};
